/**
* Методы для работы с cookie
*/

export class Cookie {

    /**
     * @param {string} name - Имя
     * @return {string}
     */

    // Получить cookie
    get(name) {
        // находим cookie по имени с помощью регулярного выражения и декодируем
        let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    /**
     * @param {string} name     - Имя
     * @param {string} value    - Значение
     * @param {object} options  - Настройки
     * @return void
     */

    // Установить cookie
    set(name, value, options = {}) {
        options = {
            path: '/',
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }
}
